import React, { useEffect, useRef, useState } from 'react';
import { SOURCE_URL} from '../../../../config';
import { useAppDispatch, useAppSelector } from '../../../../stores/hook';
import { getPackInfoById } from '../../../functions/fetchGetStarted';
import { setDetailInfoId, setPackInfoDetailStatus } from '../GetStartedSlice';
import translations from '../../../../text/get-started-translations.json';
import language from '../../../../utils/LanguageSettings';
import ImageFallback from '../../../../utils/ImageFallback';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import closeImage from '../../../../images/icon/icon-close.svg';
import defaultImgBanner from '../../../../images/icon/default-img-banner.png';

interface PackModalProps {
}

  const showDetail = ( target : any) =>{
        if(target.closest('.active')){
            target.closest('.active').getElementsByClassName("channel-content")[0].style.marginBottom = "0px";
            target.closest('.active').classList.remove("active");
            document.getElementsByClassName("channel-description")[0].classList.remove("active");
            const description = document.getElementsByClassName("channel-description")[0] as HTMLElement;
            if (description) {
                description.style.display = "none";
            }
        }else{
            const channelNo = target.closest('.channel').dataset.channelNo;
            const description = document.getElementsByClassName("channel-description")[0] as HTMLElement;
            if (description) {
                description.style.display = "none";
            }
            if (document.getElementsByClassName('channel')) {
                for (let i = 0; i < document.getElementsByClassName('channel').length; i++) {
                    document.getElementsByClassName('channel')[i].classList.remove("active");
                    const channelContent = document.getElementsByClassName('channel')[i].getElementsByClassName("channel-content")[0] as HTMLElement;
                    if(channelContent){
                        channelContent.style.marginBottom = "0px";
                    }
                }
            }
            document.getElementById(channelNo)?.classList.add("active");

            setTimeout(function () {
                var channelListOffset = document.getElementsByClassName('channel-wrapper')[0].getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
                var positionTop = target.closest(".channel").getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - channelListOffset + 114;
                description.style.top = positionTop + "px";
                description.classList.add('active');
                description.style.display = "block";
                const descHight = description.clientHeight + 20;
                const activeChannel =  document.getElementById(channelNo)?.getElementsByClassName("channel-content")[0] as HTMLElement;
                if(activeChannel){
                    activeChannel.style.marginBottom = descHight+"px";
                }
            }, 150);
        }
  }

const PackModal: React.FC<PackModalProps> = () => {
    const packDetailInfoId = useAppSelector((state) => state.getStarted.packDetailInfoId);
    const isShowDetailModal = useAppSelector((state) => state.getStarted.isShowPackInfoDetail);
    
    const pageTranslations = translations[language]; // Select the correct translations
    const defaultSrc = `${defaultImgBanner}`;

    const [info, setInfo] = useState<any>(null);
    const [isShow, setIsShow] = useState<boolean>(false);
    const [detailInfo, setDetailInfo] = useState<any>(null);
    const [showChannelNo, setShowChannelNo] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const listenerRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getPackInfoById(packDetailInfoId,language);
            if(data){
                setInfo(data);
            }
            setTimeout(function(){
                setLoading(false);
            },1000);
        };
        if (packDetailInfoId) {
            setInfo(null);
            setDetailInfo(null);
            fetchData();
        }
    }, [packDetailInfoId]);

    useEffect(() => {
        if (isShowDetailModal) {
            setLoading(true);
            setIsShow(true);
            document.getElementsByTagName("body")[0].classList.add("modal-open");
        }
    }, [isShowDetailModal]);

  useEffect(() => {
    const handleLiener = (event: any) => {
      const targetDiv = document.getElementsByClassName('pack-details')[0];
      if (targetDiv && !targetDiv.contains(event.target)) {
        handleClick();
      }
    };

    listenerRef.current = handleLiener;

    if (isShow) {
      document.addEventListener('click', handleLiener);
    } else {
      document.removeEventListener('click', handleLiener);
    }

    return () => {
      document.removeEventListener('click', listenerRef.current);
    };
  }, [isShow]);
    
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setPackInfoDetailStatus(false));
        setIsShow(false);
        dispatch(setDetailInfoId(null));
        document.getElementsByTagName("body")[0].classList.remove("modal-open");
        const description = document.getElementsByClassName("channel-description")[0] as HTMLElement;
        if (description) {
            description.style.display = "none";
        }
        for (let i = 0; i < document.getElementsByClassName('channel').length; i++) {
            document.getElementsByClassName('channel')[i].classList.remove("active");
            const channelContent = document.getElementsByClassName('channel')[i].getElementsByClassName("channel-content")[0] as HTMLElement;
            if(channelContent){
                channelContent.style.marginBottom = "0px";
            }
        }
    }

    const handleErrorImage = (event: any) => {
        event.target.src=`${defaultImgBanner}`;
    }

    const showChannelAndLibraryDetail = (data: any, className: string, event: any) => {
        setDetailInfo(data);
        if(className === "channels"){
            setShowChannelNo(true);
        }else if(className === "on-demand"){
            setShowChannelNo(false);
        }
        showDetail(event.target);
    }
    

    const fillLibraryAndChannelItem = (itemList : any, className: string) => {
        return Array.isArray(itemList) && itemList.map((item, index) => (
            <div key={index} className="channel" id={item?.attributes?.number} data-channel-no={item?.attributes?.number} onClick={(event) => showChannelAndLibraryDetail(item?.attributes, className, event)}>
                <div className="channel-content" style={{marginBottom: '0px'}}>
                    <div className="channel-logo">
                        <ImageFallback
                            primarySrc={item?.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url ? `${SOURCE_URL}` +item?.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url : item?.attributes?.icon?.data?.attributes?.url ?  `${SOURCE_URL}` +item?.attributes?.icon?.data?.attributes?.url : ''}
                            alt="Channel logo"
                        />
                    </div>
                </div>
            </div>
        ))
    } 
    if (loading) {
        return (<>
            <div className="loading-wrapper show">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        </>
        );
    }

    return (
<>  

<div className={isShow ? "modal-wrapper pack-modal show" : "modal-wrapper pack-modal"}>
            <div className="modal-dialog">
              <div className="modal-content-wrapper">
                <div className="close-wrap">
                    <div className="close-btn"><button className="close-modal" onClick={() => {handleClick()}}>{pageTranslations.Close} <img src={closeImage} alt="Close icon" /></button></div>
                </div>
                
                <div className="pack-details">
                    <img src={info?.combopack?.attributes?.packImage?.data?.attributes?.formats?.large?.url ? `${SOURCE_URL}`+info?.combopack?.attributes?.packImage?.data?.attributes?.formats?.large?.url : defaultSrc} alt="" className="pack-banner" onError={(event) => handleErrorImage(event)} />
                    <div className="container">
                        <div className="pack-about">
                            <div className="name">
                                <h3>{info?.combopack?.attributes?.name}</h3>
                            </div>
                            <div className="description">
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{info?.combopack?.attributes?.description}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
    
                
                    <div className="channel-wrapper">
                        <div className={info?.combopack?.attributes?.onDemandNumber?.data?.length ? "" : "not-display"}>
                            <div className="title-header on-demand">
                                <div className="container">
                                    <h4>{(info?.combopack?.attributes?.onDemandNumber?.data?.length ? info?.combopack?.attributes?.onDemandNumber?.data?.length : 0) + pageTranslations.OnDemandCatalogs}</h4>
                                </div>
                            </div>
        
        
                            <div className="container on-demand">
                                <div className="channel-list">
                                    {fillLibraryAndChannelItem(info?.combopack?.attributes?.onDemandNumber?.data, "on-demand")}
                                </div>
                            </div>
        
                            <div className="container remarks on-demand">
                                <div className="remarks-content">
                                    {info?.combopack?.attributes?.onDemand_remarks}
                                </div>
                            </div>
                        </div>

                        <div className={info?.combopack?.attributes?.channelsNumber?.data?.length ? "" : "not-display"}>
                            <div className="title-header linear-channels">
                                <div className="container">
                                    <h4>{(info?.combopack?.attributes?.channelsNumber?.data?.length ? info?.combopack?.attributes?.channelsNumber?.data?.length : 0) + pageTranslations.Channels}</h4>
                                </div>
                            </div>
        
                            <div className="container linear-channels">
                                <div className="channel-list">
                                    {fillLibraryAndChannelItem(info?.combopack?.attributes?.channelsNumber?.data, "channels")}
                                </div>
                            </div>
        
                            <div className="container remarks linear-channels">
                                <div className="remarks-content">
                                    {info?.combopack?.attributes?.channels_remarks}
                                </div>
                            </div>
                        </div>
    
                        <div className="channel-description">
                            <div className="container">
                                <div className="channel-name">
                                    <span style={{display: showChannelNo ? undefined : 'none'}}>{"CH. " + detailInfo?.number}</span>
                                    <h4>{detailInfo?.name}</h4>
                                </div> 
                                <p>
                                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{detailInfo?.description}</ReactMarkdown>
                                </p>
                            </div>
                        </div>
    
                    </div>
                </div>
              </div>
        
            </div>
        </div>
</>
    );
}
export default PackModal;